import { InteractionType } from '@azure/msal-browser';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from '@azure/msal-react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { UnauthenticatedBanner } from './components/FullPageBanner/UnauthenticatedBanner';
import { AccessTokenProvider } from './auth/AccessTokenContext';

// Workaround for bigint being generated by hey-api
declare global {
  interface BigInt {
    toJSON(): number;
  }
}

// eslint-disable-next-line no-extend-native
BigInt.prototype.toJSON = function () {
  return Number(this);
};

export function App() {
  useMsalAuthentication(InteractionType.Redirect);

  return (
    <>
      <AuthenticatedTemplate>
        <AccessTokenProvider>
          <RouterProvider router={router} />
        </AccessTokenProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnauthenticatedBanner />
      </UnauthenticatedTemplate>
    </>
  );
}
